import React, { CSSProperties } from 'react'

import styles from './AudurButton.module.scss'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	displayBlock?: boolean
	style?: CSSProperties
	size?: 'small' | 'medium' | 'large'
	variant?: 'filled' | 'outlined' | 'text'
	backgroundType?: 'light' | 'dark'
	loading?: boolean
	icon?: React.ReactNode
	iconPlacement?: 'left' | 'right'
	alignTextCenter?: boolean
}

const AudurButton: React.FunctionComponent<ButtonProps> = ({
	type = 'button',
	className = '',
	onClick,
	displayBlock = false,
	disabled,
	style,
	children,
	size = 'medium',
	variant = 'filled',
	loading = false,
	backgroundType = 'dark',
	icon,
	iconPlacement = 'left',
	alignTextCenter = false,
	...rest
}) => {
	const arrClassName = [styles.button]
	if (disabled) arrClassName.push(styles.disabled)
	if (displayBlock) arrClassName.push(styles.block)
	if (loading) arrClassName.push(styles.loading)
	if (backgroundType === 'light') arrClassName.push(styles.lightBackground)
	if (alignTextCenter) arrClassName.push(styles.alignTextCenter)
	if (className !== '') arrClassName.push(className)
	arrClassName.push(styles[size])
	arrClassName.push(styles[variant])

	return (
		<button
			type={type}
			className={arrClassName.join(' ')}
			onClick={onClick}
			disabled={disabled}
			{...rest}
			style={style}
		>
			{icon && iconPlacement === 'left' && <span>{icon}</span>}
			<div>{children}</div>
			{icon && iconPlacement === 'right' && <span>{icon}</span>}
		</button>
	)
}

export default AudurButton
